import { Component } from "react";

async function nukeAllCachesAndReload() {
  try {
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((r) => r.unregister()));
    }
    if ("caches" in window) {
      const names = await caches.keys();
      await Promise.all(names.map((n) => caches.delete(n)));
    }
    localStorage.clear();
  } catch (e) {
    // best-effort cleanup
  }
  location.reload();
}

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary]", error, errorInfo);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        dir="rtl"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          fontFamily: "Vazirmatn, system-ui, sans-serif",
          background: "#f9fafb",
          padding: "1rem",
        }}
      >
        <div style={{ textAlign: "center", maxWidth: 400 }}>
          <div
            style={{
              fontSize: "3rem",
              marginBottom: "0.5rem",
              lineHeight: 1,
            }}
          >
            &#9888;
          </div>
          <h1
            style={{
              fontSize: "1.25rem",
              fontWeight: 700,
              color: "#dc2626",
              marginBottom: "0.5rem",
            }}
          >
            خطای غیرمنتظره
          </h1>
          <p style={{ color: "#6b7280", marginBottom: "1.5rem" }}>
            متأسفانه خطایی رخ داده است. لطفاً یکی از گزینه‌های زیر را امتحان
            کنید.
          </p>
          {import.meta.env.DEV && this.state.error ? (
            <pre
              style={{
                textAlign: "left",
                direction: "ltr",
                fontSize: "0.75rem",
                color: "#991b1b",
                background: "#fef2f2",
                padding: "0.75rem",
                borderRadius: "0.375rem",
                marginBottom: "1rem",
                overflow: "auto",
                maxHeight: "8rem",
              }}
            >
              {this.state.error?.message || String(this.state.error)}
            </pre>
          ) : null}
          <div
            style={{
              display: "flex",
              gap: "0.75rem",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <button
              onClick={() => location.reload()}
              style={{
                padding: "0.5rem 1.25rem",
                borderRadius: "0.375rem",
                border: "1px solid #d1d5db",
                background: "#fff",
                cursor: "pointer",
                fontSize: "0.875rem",
              }}
            >
              بارگذاری مجدد
            </button>
            <button
              onClick={nukeAllCachesAndReload}
              style={{
                padding: "0.5rem 1.25rem",
                borderRadius: "0.375rem",
                border: "none",
                background: "#2563eb",
                color: "#fff",
                cursor: "pointer",
                fontSize: "0.875rem",
              }}
            >
              پاکسازی داده‌ها و بارگذاری مجدد
            </button>
          </div>
        </div>
      </div>
    );
  }
}
